import { jsx as _jsx } from "react/jsx-runtime";
import { ListSubheader, MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
/**
 * A section's heading in the menu. The select hands every child the props
 * of an option; a heading keeps none of them, so it is neither announced
 * nor chosen, and the keyboard skips it as it does a `ListSubheader`.
 */
function SectionHeading(_a) {
    var children = _a.children;
    return (_jsx(ListSubheader, { role: "presentation", sx: { lineHeight: "32px" }, children: children }));
}
SectionHeading.muiSkipListHighlight = true;
/**
 * The dashboard ▾ menu: every dashboard of the event, in the configured
 * order, each section's under its heading.
 */
export function MonitoringSwitcher(_a) {
    var _b;
    var dashboards = _a.dashboards, dashboardId = _a.dashboardId, onChange = _a.onChange;
    var t = useTranslation().t;
    var items = [];
    var section;
    for (var _i = 0, dashboards_1 = dashboards; _i < dashboards_1.length; _i++) {
        var dashboard = dashboards_1[_i];
        var next = (_b = dashboard.section) !== null && _b !== void 0 ? _b : null;
        if (next && next !== section) {
            items.push(_jsx(SectionHeading, { children: next }, "section:".concat(next)));
        }
        section = next;
        items.push(_jsx(MenuItem, { value: dashboard.id, sx: next ? { pl: 3 } : undefined, children: dashboard.title }, dashboard.id));
    }
    return (_jsx(TextField, { id: "monitoring-dashboard", select: true, size: "small", label: t("monitoring.header.dashboard"), value: dashboardId, onChange: function (event) { return onChange(event.target.value); }, fullWidth: false, sx: { width: { xs: "100%", md: 260 } }, children: items }));
}
